import { toast } from '@/components/toast';
import { useAnalytics } from '@/services/analytics';
import { deleteImage } from '@/services/api';
import { GET_PRESENTERS_KEY_TYPE } from '@/state/presenters';
import { ImageType, Presenter } from '@d-id/types';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';

export function useDeleteImage(imageType: ImageType) {
    const mixpanel = useAnalytics();
    const queryClient = useQueryClient();

    return useMutation(deleteImage, {
        onSuccess(_data, imageId) {
            queryClient.setQueryData(GET_PRESENTERS_KEY_TYPE(imageType), (oldPresenters: Presenter[] = []) =>
                oldPresenters.filter(presenter => presenter.id !== imageId)
            );
            mixpanel?.track('delete-image', { event: 'success' });
        },

        onError(error: AxiosError<{ kind: string; description?: string }>) {
            const kind = error?.response?.data?.kind;
            mixpanel?.track('delete-image', { kind, event: 'error' });
            toast.error({
                title: `Failed to delete ${imageType === ImageType.Backgrounds ? 'image' : 'avatar'}, please try again`,
                toastId: `delete-presenter-error`,
            });
        },
    });
}
